
























































































import { Vue, Component } from 'vue-property-decorator';
import firebase from 'firebase/app';
import 'firebase/database';
import { vxm } from '@/store';
import LineIcon from '@/components/svg/LineIcon.vue';

@Component({
  components: {
    LineIcon,
  },
})
export default class extends Vue {
  private testDate = 0;
  private today = Date.now();
  private ticker!: number;
  private vdoList = [
    {
      caption: 'Video ที่ 1: ภาพรวมระบบ EHB',
      url:
        'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fregis-btn-1.png?alt=media&token=a39d2b5a-10da-40f0-b4db-7e170c23ea2e',
      route: '2/1?update=false',
    },
    {
      caption: 'Video ที่ 2: การเข้าสู่ web ระบบเรียนออนไลน์',
      url:
        'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fregis-btn-2.png?alt=media&token=66abcf7e-b0b8-4596-a894-288c6b4220e1',
      route: '2/2?update=false',
    },
    {
      caption: 'Video ที่ 3: การเรียนในห้อง live',
      url:
        'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fregis-btn-3.png?alt=media&token=361f9e11-721b-4aa3-8803-c5442c25e594',
      route: '2/3?update=false',
    },
    {
      caption: 'Video ที่ 4: การเรียนนอกห้อง live และการส่งการบ้าน',
      url:
        'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fregis-btn-4.png?alt=media&token=6de67c6c-c9f1-4d9f-af12-647d46c50ee3',
      route: '2/4?update=false',
    },
    {
      caption: 'Video ที่ 5: วิธีการตรวจงาน',
      url:
        'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fregis-btn-5.png?alt=media&token=b8386eb2-5e1d-4351-af4b-dc266b41d6a2',
      route: '2/5?update=false',
    },
    {
      caption: 'Video ที่ 6: การใช้งาน office lens',
      url:
        'https://firebasestorage.googleapis.com/v0/b/monkeyproduction.appspot.com/o/static%2Fregis-btn-6.png?alt=media&token=03d8d622-4239-4515-a969-6ece500898f1',
      route: '2/6?update=false',
    },
  ];

  private get testDateStr() {
    if (this.testDate !== 0) {
      const date = new Date(this.testDate);
      const dow = [
        'อาทิตย์',
        'จันทร์',
        'อังคาร',
        'พุธ',
        'พฤหัส',
        'ศุกร์',
        'เสาร์',
      ];
      const month = [
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม',
      ];

      return `วัน${dow[date.getDay()]}ที่ ${date.getDate()} ${
        month[date.getMonth()]
      } เวลา ${date.getHours()}:00 น.`;
    }
    return 'กำลังโหลด';
  }

  private get waitingTime() {
    if (this.testDate !== 0) {
      const diff = this.testDate - this.today;
      const day = Math.floor(diff / (24 * 60 * 60 * 1000));
      const hour = Math.floor(
        (diff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
      );
      const min = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));
      return `${day} วัน ${hour} ชั่วโมง ${min} นาที`;
    }
    return 'กำลังโหลด';
  }

  mounted() {
    this.ticker = window.setInterval(() => {
      this.today = Date.now();
      if (this.testDate !== 0 && this.testDate - this.today <= 0) {
        const ref = firebase.database().ref('pr/new-user');
        ref
          .update({
            [`${vxm.login.getUserId}/step`]: '4.1',
          })
          .then(() => {
            this.$router.push('4');
            clearInterval(this.ticker);
          });
      }
    }, 1000);
    this.checkTestDate();
    const { update } = this.$route.query;
    if (update !== 'false') {
      const ref = firebase.database().ref('pr/new-user');
      ref.update({
        [`${vxm.login.getUserId}/step`]: '3',
      });
    }
  }

  private async checkTestDate() {
    const ref = firebase.database().ref(`pr/new-user/${vxm.login.getUserId}`);
    try {
      const val = (await ref.once('value')).val();
      this.testDate = val.testDate;
    } catch (error) {
      console.log(error);
    }
  }
}
